import { _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx } from 'react/jsx-runtime';
import ReactMarkdown from 'react-markdown';
import { M as MarkdownLinkRenderer } from './MarkdownLinkRenderer-fec62927.js';

/**
 * Renders a simple markdown string as a React component. Renders inline elements only.
 */
var SimpleMarkdown = function (_a) {
    var children = _a.children;
    if (!children) {
        return null;
    }
    return (jsx(ReactMarkdown, __assign({ disallowedTypes: [
            'blockquote',
            'break',
            'code',
            'heading',
            'inlineCode',
            'list',
            'listItem',
            'table',
            'tableCell',
            'tableRow',
        ], renderers: {
            link: MarkdownLinkRenderer,
            paragraph: 'span',
            strong: 'b',
        }, unwrapDisallowed: true }, { children: children }), void 0));
};

export { SimpleMarkdown as S };
